var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upper-part"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":"/"}})],1),_c('mobile-icons'),_c('search-bar')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }